/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./quotes.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import Chip from "@mui/material/Chip";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../../helper/numberFormatter";
import {formatDate} from "../../../helper/dateFormatter";

const QuoteTable = (props) => {
  const navigate = useNavigate();
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table + " " + "newGlobalTable"}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow
              className="global-custom-sorting-header"
              onClick={(e) => {
                props.updateSorting("quoteId");
              }}
            >
              <TableCell>
                <b>{props.t("QUOTE_ID")}</b>
                {props.sortBy === "quoteId" ? (
                  <span className="material-icons">
                    {/* sometimes during page load expand_less or expand_more would show up beside table headers and would not look good */}
                    {props.sortOrder === "DESC" ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {props.view !== "quotesByCustomer" && (
                <>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateSorting("customerName");
                    }}
                  >
                    <b>{props.t("CUSTOMER_NAME")}</b>
                    {props.sortBy === "customerName" ? (
                      <span className="material-icons">
                        {/* sometimes during page load expand_less or expand_more would show up beside table headers and would not look good */}
                        {props.sortOrder === "DESC" ? (
                          <KeyboardArrowUp />
                        ) : (
                          <KeyboardArrowDown />
                        )}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell>
                    <b>{props.t("CUSTOMER_BAN")}</b>
                  </TableCell>
                </>
              )}
              <TableCell>
                <b>{props.t("TYPE")}</b>
              </TableCell>

              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("createdTxStamp");
                }}
              >
                <b>{props.t("QUOTE_DATE")}</b>
                {props.sortBy === "createdTxStamp" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell>
                <b>{props.t("STATUS")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show quotes list */}
            {props.quotes.map((row) => (
              <TableRow
                key={row.quoteId}
                hover
                className={classes.rowClass + " " + "orderTableRow"}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/quote/${row.quoteId}`);
                }}
                // onClick={(e) => {
                //     e.stopPropagation();
                //     props.providerType === 'SOLUTION_PROVIDER' ?
                //         navigate(`/quote/${row.quoteId}?tenantId=${props.tenantId}`)
                //         :
                //         navigate(`/quote/${row.quoteId}`)
                // }}
              >
                <TableCell>{row.quoteId}</TableCell>
                {props.view !== "quotesByCustomer" && (
                  <>
                    <TableCell>{row.customerName}</TableCell>
                    <TableCell>{row.customerBan}</TableCell>
                  </>
                )}
                <TableCell>{row.typeDescription}</TableCell>

                <TableCell>
                  {formatDate(row.createdDateTime)}
                </TableCell>
                <TableCell>
                  {/* {row.quoteStatus} */}
                  {row.quoteStatus === "Quote Ordered" ||
                  row.quoteStatus === "Order Submitted" ? (
                    <Chip
                      size="normal"
                      className="successChip"
                      label={props.t(row.quoteStatus)}
                    />
                  ) : (
                    <Chip
                      size="normal"
                      className="inProgressChip"
                      label={props.t(row.quoteStatus)}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
            {/* If there is no quotes to show */}
            {props.showLoading && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {props.t("LOADING")}
                </TableCell>
              </TableRow>
            )}
            {!props.showLoading && props.quotes.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {props.t("NO_QUOTE_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalQuoteCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalQuoteCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {props.t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            count={Math.ceil(props.totalQuoteCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(QuoteTable);
